import EachFibLevels, {
  fibLevelsPropTypes,
  fibLevelsDefaultProps,
} from "./EachFibLevels";

// Config sobre EachFibLevels (auditoria 2026-07-17, item 1c)
class EachFibRetracement extends EachFibLevels {}

EachFibRetracement.defaultLevels = [
  { level: 100, display: true },
  { level: 61.8, display: true },
  { level: 50, display: true },
  { level: 38.2, display: true },
  { level: 23.6, display: true },
  { level: 0, display: true },
];
// Retracement: nível 0 no ponto final (y2), 100 no inicial
EachFibRetracement.computeLevelY = ({ level, y2, dy }) =>
  y2 - (level / 100) * dy;
EachFibRetracement.percentDigits = 2;

EachFibRetracement.propTypes = fibLevelsPropTypes;
EachFibRetracement.defaultProps = fibLevelsDefaultProps;

export default EachFibRetracement;
